var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRightCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.702 6.405A.586.586 0 005.876 6a.567.567 0 00-.174-.404L.906 1.098a.533.533 0 00-.763.032.557.557 0 00.031.778L4.538 6 .174 10.092a.557.557 0 00-.031.778.533.533 0 00.763.032l4.796-4.497z",
    fill: "#B6B7DB"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDYgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik01LjcwMTkzIDYuNDA0NzdDNS44NDg1OSA2LjI1NTQgNS44NzYxNiA2LjA4Nzk3IDUuODc2MTYgNS45OTk5QzUuODc2MTYgNS45MDE2MiA1Ljg0OTQzIDUuNzQ1NzkgNS43MDE5MyA1LjU5NTU3TDAuOTA1ODQzIDEuMDk4NDZDMC42ODYzNjIgMC44OTI2MzcgMC4zNDQ3NDkgMC45MDcwMzIgMC4xNDI3NzYgMS4xMzA0N0MtMC4wNTkzMDE5IDEuMzU0MTIgLTAuMDQ0NjQxOCAxLjcwMTk1IDAuMTc0MzExIDEuOTA3NTZMNC41MzgxMiA2LjAwMDA3TDAuMTc0MzExIDEwLjA5MjVDLTAuMDQ1Mjc0NiAxMC4yOTg1IC0wLjA1OTE5NjQgMTAuNjQ2NCAwLjE0Mjc3NiAxMC44Njk3QzAuMzQ0NzQ5IDExLjA5MzEgMC42ODYzNjIgMTEuMTA3NSAwLjkwNTg0MyAxMC45MDE4TDUuNzAxOTMgNi40MDQ3N1oiIGZpbGw9IiNCNkI3REIiLz4KPC9zdmc+Cg==";
export { SvgRightCaret as ReactComponent };